export default from './input-text';



// WEBPACK FOOTER //
// ./app/components/input-text/index.js